import Toolbar from './src/toolbar.js';

export default { Toolbar };